import React from "react";
import Navbar from "../../components/Navbar";

function TermsAndConditions() {
    return (
        <>
            <Navbar />
            <div className="container">
                <div className="justify-content-sm-center pt-5">
                    <h2 style={{ textAlign: "center", padding: "13%" }}>
                        <u>TERMS AND CONDITIONS</u>
                    </h2>
                    <h5>Last Updated: Oct 24, 2025</h5>
                    <br />
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <p style={{ color: "black" }}>
                            For easily managing restaurants Software subscription, we have
                            integrated digital payments for restaurateurs who can avail via
                            paying through online Payment Gateway. Below are the Terms and
                            Conditions for the same.
                        </p>
                        <br />
                        <h4>Overview</h4>
                        <div>
                            <ul style={{ color: "black" }} className="custom-li-bullet-points">
                                <li>
                                    This website is operated by SassyMonks Pvt Ltd (“FleetOrder”).
                                    Throughout the site, the terms “we”, “us” and “our” refer to
                                    SassyMonks Pvt Ltd. SassyMonks Pvt Ltd offers FleetOrder
                                    Platform (Website, Mobile Application) for managing restaurants,
                                    including all information, tools and services available from
                                    this site to you, the user, conditioned upon your acceptance of
                                    all terms, conditions, policies and notices stated here.
                                </li>
                                <li>
                                    By visiting our site and/ or subscribing to FleetOrder
                                    Platform, you engage in our “Service” and agree to be bound by
                                    the following terms and conditions (“Terms of Service”,
                                    “Terms”), including those additional terms and conditions and
                                    policies referenced herein and/or available by hyperlink. These
                                    Terms of Service apply to all users of FleetOrder Platform,
                                    including without limitation users who are browsers, vendors,
                                    customers, merchants, and/ or contributors of content.
                                </li>
                                <li>
                                    Please read these Terms of Service carefully before accessing or
                                    subscribing our FleetOrder Platform. By accessing or using any
                                    part of the platform, you agree to be bound by these Terms of
                                    Service. If you do not agree to all the terms and conditions of
                                    this agreement, then you may not access the FleetOrder Platform
                                    or use any services. If these Terms of Service are considered an
                                    offer, acceptance is expressly limited to these Terms of
                                    Service.
                                </li>
                                <li>
                                    Any new features or tools which are added to the current
                                    FleetOrder Platform l also be subject to the Terms of Service.
                                    You can review the most current version of the Terms of Service
                                    at any time on this page. We reserve the right to update, change
                                    or replace any part of these Terms of Service by posting
                                    updates and/or changes to our website. It is your responsibility
                                    to check this page periodically for changes. Your continued use
                                    of or access to the website following the posting of any changes
                                    constitutes acceptance of those changes.
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* FleetOrder Terms */}
                    <div className="col-md-12">
                        <br />
                        <h4>FleetOrder Terms</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                By agreeing to these Terms of Service, you represent that you are
                                running F&amp;B outlet and also should be the age of majority in
                                your state or province of residence.
                            </li>
                            <li>
                                You may not use our platform for any illegal or unauthorised
                                purpose nor may you, in the use of the Service, violate any laws
                                in your jurisdiction (including but not limited to copyright
                                laws).
                            </li>
                            <li>
                                You must not transmit any worms or viruses or any code of a
                                destructive nature.
                            </li>
                            <li>
                                A breach or violation of any of the Terms will result in an
                                immediate termination of your Services.
                            </li>
                        </ul>
                    </div>

                    {/* General Conditions */}
                    <div className="col-md-12">
                        <br />
                        <h4>General Conditions</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>We reserve the right to refuse service to anyone for any reason at any time.</li>
                            <li>
                                You understand that your content (not including credit card
                                information), may be transferred unencrypted and involve (a)
                                transmissions over various networks; and (b) changes to conform
                                and adapt to technical requirements of connecting networks or
                                devices. Credit card information is always encrypted during
                                transfer over networks.
                            </li>
                            <li>
                                You agree not to reproduce, duplicate, copy, sell, resell or
                                exploit any portion of the Service, use of the Service, or access
                                to the Service or any contact on the website through which the
                                service is provided, without express written permission by us.
                            </li>
                            <li>
                                The headings used in this agreement are included for convenience
                                only and will not limit or otherwise affect these Terms.
                            </li>
                        </ul>
                    </div>

                    {/* Modifications */}
                    <div className="col-md-12">
                        <br />
                        <h4>MODIFICATIONS TO THE SERVICE AND PRICES</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>Subscription Price for FleetOrder are subject to change without notice.</li>
                            <li>
                                We reserve the right at any time to modify or discontinue the
                                Service (or any part or content thereof) without notice at any
                                time.
                            </li>
                            <li>
                                We shall not be liable to you or to any third-party for any
                                modification, price change, suspension or discontinuance of the
                                Service.
                            </li>
                        </ul>
                    </div>

                    {/* Products or Services */}
                    <div className="col-md-12">
                        <br />
                        <h4>PRODUCTS OR SERVICES</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                We are not responsible for any purchase of hardware devices like
                                thermal printers, cash drawers from outside and not working
                                properly.
                            </li>
                            <li>
                                To Avail our platform or services you should have F&amp;B outlet
                                which is under working.
                            </li>
                        </ul>
                    </div>

                    {/* Third Party Links */}
                    <div className="col-md-12">
                        <br />
                        <h4>THIRD-PARTY LINKS</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                Certain content, products and services available via our Service
                                may include materials from third-parties.
                            </li>
                            <li>
                                Third-party links on this site may direct you to third-party
                                websites that are not affiliated with us. We are not responsible
                                for examining or evaluating the content or accuracy and we do not
                                warrant and will not have any liability or responsibility for any
                                third-party materials or websites, or for any other materials,
                                products, or services of third-parties.
                            </li>
                            <li>
                                We are not liable for any harm or damages related to the purchase
                                or use of goods, services, resources, content, or any other
                                transactions made in connection with any third-party websites.
                                Please review carefully the third-party's policies and practices
                                and make sure you understand them before you engage in any
                                transaction. Complaints, claims, concerns, or questions regarding
                                third-party products should be directed to the third-party.
                            </li>
                        </ul>
                    </div>

                    {/* Personal Information */}
                    <div className="col-md-12">
                        <br />
                        <h4>PERSONAL INFORMATION</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                Your submission of personal information through our platform is
                                governed by our Privacy Policy.
                            </li>
                        </ul>
                    </div>

                    {/* Prohibited Uses */}
                    <div className="col-md-12">
                        <br />
                        <h4>PROHIBITED USES</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                In addition to other prohibitions as set forth in the Terms of
                                Service, you are prohibited from using the site or its content:
                                (a) for any unlawful purpose; (b) to solicit others to perform or
                                participate in any unlawful acts; (c) to violate any
                                international, federal, provincial or state regulations, rules,
                                laws, or local ordinances; (d) to infringe upon or violate our
                                intellectual property rights or the intellectual property rights
                                of others; (e) to harass, abuse, insult, harm, defame, slander,
                                disparage, intimidate, or discriminate based on gender, sexual
                                orientation, religion, ethnicity, race, age, national origin, or
                                disability; (f) to submit false or misleading information; (g) to
                                upload or transmit viruses or any other type of malicious code
                                that will or may be used in any way that will affect the
                                functionality or operation of the Service or of any related
                                website, other websites, or the Internet; (h) to collect or track
                                the personal information of others; (i) to spam, phish, pharm,
                                pretext, spider, crawl, or scrape; (j) for any obscene or immoral
                                purpose; or (k) to interfere with or circumvent the security
                                features of the Service or any related website, other websites, or
                                the Internet. We reserve the right to terminate your use of the
                                Service or any related website for violating any of the prohibited
                                uses.
                            </li>
                        </ul>
                    </div>

                    {/* Disclaimer */}
                    <div className="col-md-12">
                        <br />
                        <h4>DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                We do not warrant that the results that may be obtained from the
                                use of the service will be accurate or reliable.
                            </li>
                            <li>
                                You agree that from time to time we may remove the service for
                                indefinite periods of time or cancel the service at any time,
                                without notice to you.
                            </li>
                            <li>
                                In no case shall SassyMonks Pvt Ltd, our directors, officers,
                                employees, affiliates, agents, contractors, interns, suppliers,
                                service providers or licensors be liable for any injury, loss,
                                claim, or any direct, indirect, incidental, punitive, special, or
                                consequential damages of any kind, including, without limitation
                                lost profits, lost revenue, lost savings, loss of data,
                                replacement costs, or any similar damages, whether based in
                                contract, tort (including negligence), strict liability or
                                otherwise, arising from your use of any of the service or any
                                products procured using the service, or for any other claim
                                related in any way to your use of the service or any product,
                                including, but not limited to, any errors or omissions in any
                                content, or any loss or damage of any kind incurred as a result of
                                the use of the service or any content (or product) posted,
                                transmitted, or otherwise made available via the service, even if
                                advised of their possibility. Because some states or jurisdictions
                                do not allow the exclusion or the limitation of liability for
                                consequential or incidental damages, in such states or
                                jurisdictions, our liability shall be limited to the maximum
                                extent permitted by law.
                            </li>
                        </ul>
                    </div>

                    {/* Indemnification */}
                    <div className="col-md-12">
                        <br />
                        <h4>INDEMNIFICATION</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                You agree to indemnify, defend and hold harmless SassyMonks Pvt
                                Ltd and our parent, subsidiaries, affiliates, partners, officers,
                                directors, agents, contractors, licensors, service providers,
                                subcontractors, suppliers, interns and employees, harmless from
                                any claim or demand, including reasonable attorneys’ fees, made by
                                any third-party due to or arising out of your breach of these
                                Terms of Service or the documents they incorporate by reference,
                                or your violation of any law or the rights of a third-party.
                            </li>
                        </ul>
                    </div>

                    {/* Severability */}
                    <div className="col-md-12">
                        <br />
                        <h4>SEVERABILITY</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                In the event that any provision of these Terms of Service is
                                determined to be unlawful, void or unenforceable, such provision
                                shall nonetheless be enforceable to the fullest extent permitted
                                by applicable law, and the unenforceable portion shall be deemed
                                to be severed from these Terms of Service, such determination
                                shall not affect the validity and enforceability of any other
                                remaining provisions.
                            </li>
                        </ul>
                    </div>

                    {/* Termination */}
                    <div className="col-md-12">
                        <br />
                        <h4>TERMINATION</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                The obligations and liabilities of the parties incurred prior to
                                the termination date shall survive the termination of this
                                agreement for all purposes.
                            </li>
                            <li>
                                These Terms of Service are effective unless and until terminated
                                by either you or us. You may terminate these Terms of Service at
                                any time by notifying us that you no longer wish to use our
                                Services, or when you cease using our site.
                            </li>
                            <li>
                                If in our sole judgment you fail, or we suspect that you have
                                failed, to comply with any term or provision of these Terms of
                                Service, we also may terminate this agreement at any time without
                                notice and you will remain liable for all amounts due up to and
                                including the date of termination; and/or accordingly may deny you
                                access to our Services (or any part thereof).
                            </li>
                        </ul>
                    </div>

                    {/* Entire Agreement */}
                    <div className="col-md-12">
                        <br />
                        <h4>ENTIRE AGREEMENT</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                The failure of us to exercise or enforce any right or provision of
                                these Terms of Service shall not constitute a waiver of such right
                                or provision.
                            </li>
                            <li>
                                These Terms of Service and any policies or operating rules posted
                                by us on this site or in respect to The Service constitutes the
                                entire agreement and understanding between you and us and govern
                                your use of the Service, superseding any prior or contemporaneous
                                agreements, communications and proposals, whether oral or written,
                                between you and us (including, but not limited to, any prior
                                versions of the Terms of Service).
                            </li>
                            <li>
                                Any ambiguities in the interpretation of these Terms of Service
                                shall not be construed against the drafting party.
                            </li>
                        </ul>
                    </div>

                    {/* Governing Law */}
                    <div className="col-md-12">
                        <br />
                        <h4>GOVERNING LAW</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                These Terms of Service and any separate agreements whereby we
                                provide you Services shall be governed by and construed in
                                accordance with the laws of India and jurisdiction of Hyderabad,
                                Telangana.
                            </li>
                        </ul>
                    </div>

                    {/* Changes to Terms */}
                    <div className="col-md-12">
                        <br />
                        <h4>CHANGES TO TERMS OF SERVICE</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>
                                You can review the most current version of the Terms of Service at
                                any time at this page.
                            </li>
                            <li>
                                We reserve the right, at our sole discretion, to update, change or
                                replace any part of these Terms of Service by posting updates and
                                changes to our website. It is your responsibility to check our
                                website periodically for changes. Your continued use of or access
                                to our website or the Service following the posting of any changes
                                to these Terms of Service constitutes acceptance of those changes.
                            </li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="col-md-12">
                        <br />
                        <h4>CONTACT INFORMATION</h4>
                        <ul style={{ color: "black" }} className="custom-li-bullet-points">
                            <li>Questions about the Terms of Service should be sent to us.</li>
                        </ul>
                        <br />
                        <br />
                        <br />
                        <br />
                    </div>
                </div>
            </div>
        </>
    );
}

export default TermsAndConditions;
